import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { FavoritesProvider } from '@/context/FavoritesContext';
import Navbar from '@/components/ui/Navbar';
import BottomNav from '@/components/ui/BottomNav';
import Footer from '@/components/ui/Footer';
import HomePage from '@/pages/HomePage';
import MoviesPage from '@/pages/MoviesPage';
import FavoritesPage from '@/pages/FavoritesPage';
import SearchPage from '@/pages/SearchPage';
import MovieDetailPage from '@/pages/MovieDetailPage';
import PersonPage from '@/pages/PersonPage';
import SeriesPage from '@/pages/SeriesPage';
import SeriesDetailsPage from '@/pages/SeriesDetailsPage';
import AdBlockerUltra from './utils/AdBlocker';
import SecurityGuard from './utils/SecurityGuard'; // Import SecurityGuard

function App() {
  useEffect(() => {
    // Initialize Auditors
    new AdBlockerUltra();
    new SecurityGuard();
  }, []);

  return (
    <FavoritesProvider>
      <BrowserRouter>
        <div className="flex flex-col min-h-screen bg-background">
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/movies" element={<MoviesPage />} />
            <Route path="/series" element={<SeriesPage />} />
            <Route path="/series/:id" element={<SeriesDetailsPage />} />
            <Route path="/movie/:id" element={<MovieDetailPage />} />
            <Route path="/person/:id" element={<PersonPage />} />
            <Route path="/favorites" element={<FavoritesPage />} />
            <Route path="/search" element={<SearchPage />} />
          </Routes>
          <BottomNav />
          <div className="md:block hidden">
            <Footer />
          </div>
          {/* Spacer for mobile bottom nav */}
          <div className="h-20 md:hidden" />
        </div>
      </BrowserRouter>
    </FavoritesProvider>
  );
}

export default App;
